import { useNavigate } from "react-router-dom";

/**
 * Barre d'onglets unifiée pour l'espace "Dossiers".
 * Présente sur /dossiers (3 sous-vues actives) et sur /signes, /perdus (archives).
 *
 * Tabs internes (filtrage dans Dossiers.jsx) : montage | envoyer | banque
 * Tabs nav (page dédiée existante) : signes → /signes, perdus → /perdus
 *
 * Objectif : permettre l'accès aux archives depuis mobile sans passer par la sidebar desktop.
 */

export const DOSSIERS_TABS = [
  { key: "standby", label: "Stand-by", route: "/standby", internal: false },
  { key: "montage", label: "En montage", route: "/dossiers?tab=montage", internal: true },
  { key: "envoyer", label: "À envoyer", route: "/dossiers?tab=envoyer", internal: true },
  { key: "banque", label: "En banque", route: "/dossiers?tab=banque", internal: true },
  { key: "signes", label: "Signés", route: "/signes", internal: false },
  { key: "perdus", label: "Annulés", route: "/perdus", internal: false },
];

/**
 * @param {string} activeKey - clé de l'onglet actif
 * @param {(tab) => void} onInternalSelect - callback quand un tab interne est cliqué (sinon navigation)
 */
export default function DossiersTabs({ activeKey, onInternalSelect }) {
  const navigate = useNavigate();

  const handle = (tab) => {
    if (tab.key === activeKey) return;
    if (tab.internal && onInternalSelect) {
      onInternalSelect(tab);
    } else {
      navigate(tab.route);
    }
  };

  return (
    <div
      className="flex flex-wrap gap-1 bg-slate-100 rounded-xl p-1 mb-4"
      role="tablist"
      data-testid="dossiers-tabs"
    >
      {DOSSIERS_TABS.map((t) => {
        const isActive = t.key === activeKey;
        return (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => handle(t)}
            className={`px-3 py-1.5 rounded-lg text-[13px] font-bold transition-colors ${
              isActive ? "bg-white text-slate-900 shadow-sm" : "text-slate-500 hover:text-slate-700"
            }`}
            data-testid={`dossiers-tab-${t.key}`}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
